/* eslint-disable max-len */

/**
 * @author: Matthew Rawson @ 04/09/2017 14:47
 * @description: Custom Time Icon created as a React element in a similar manner to react-icons.
 * @notes: Could be moved to icon font file when that is implemented
 */
import React from "react"
import BaseSvgIcon from "./Base"

const Time = (props) => {
  return (
    <BaseSvgIcon {...props}>
      <path d="M10 8.6L8.687 9.916c-.195.195-.512.195-.707 0-.195-.196-.195-.512 0-.707l2.07-2.07c.013-.014.028-.027.043-.04.09-.126.24-.208.407-.208.276 0 .5.223.5.5v5.87c0 .277-.224.5-.5.5s-.5-.223-.5-.5V8.6zM6.324 3.99c-.12-.074-.196-.2-.203-.34-.025-.13.008-.266.09-.372l.617-1.98c.07-.222.31-.348.536-.28.227.07.355.304.285.527l-.38 1.22c3.745-1.34 8.005.245 9.86 3.82 2.004 3.863.438 8.59-3.5 10.558-3.936 1.968-8.752.43-10.757-3.434-.55-1.065-.843-2.217-.87-3.384-.006-.255.2-.466.46-.472.26-.006.475.196.48.45.024 1.03.282 2.046.77 2.986 1.77 3.41 6.018 4.767 9.492 3.03 3.473-1.736 4.856-5.908 3.087-9.317C14.606 3.76 10.68 2.375 7.313 3.74L8.49 5.246c.16.203.12.493-.087.648-.206.155-.502.116-.66-.086l-1.42-1.82z" />
    </BaseSvgIcon>
  )
}

export default Time
